import type {
  RestorePersonSeatCommand,
  RestorePersonSeatResult,
} from "@/domain/model/AccountSeatOverview";
import type { AccountManagementService } from "@/domain/port/AccountManagementService";

export class RestorePersonSeat {
  constructor(private readonly service: AccountManagementService) {}

  execute(
    command: RestorePersonSeatCommand,
    signal?: AbortSignal,
  ): Promise<RestorePersonSeatResult> {
    return this.service.restorePersonSeat(command, signal);
  }
}
